import {NUMBER} from "../../constants/app-constants";
export const modelYearNameGenerator = (modelYear) => {
    if (modelYear && Number(modelYear)) {
        return `MY${modelYear.slice(NUMBER.MINUS_TWO)}`;
    } else {
        return "";
    }
};
